/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nocountryfound2Inputs */

const he_common_nocountryfound2 = /** @type {(inputs: Common_Nocountryfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נמצאה מדינה.`)
};

const en_common_nocountryfound2 = /** @type {(inputs: Common_Nocountryfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No country found.`)
};

/**
* | output |
* | --- |
* | "No country found." |
*
* @param {Common_Nocountryfound2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_nocountryfound2 = /** @type {((inputs?: Common_Nocountryfound2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nocountryfound2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_nocountryfound2(inputs)
	return en_common_nocountryfound2(inputs)
});
export { common_nocountryfound2 as "common_noCountryFound" }